module.exports = __webpack_public_path__ + "static/media/BeingPhysicallyActiveDuringCovid-19.28151a7b.jpg";